import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="pt-28 min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <h1 className="font-serif-display text-7xl text-primary-gold">404</h1>
        <p className="text-soft mt-4">This page drifted out of time.</p>
        <Link
          to="/"
          className="btn-gold inline-flex px-8 py-4 mt-10 font-mono-ui text-xs uppercase tracking-[0.18em]"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
